export default {
  text: 'Utilizzando questo sito web accetti la nostra',
  cookie_policy: 'Informativa sui cookie.',
  buttons: {
    accept: 'Accetta',
    reject: 'Rifiuta',
  },
};
